export const translations = {
    en: {
        // menu =>
        companyName: "barge sabz",

        contactUs: "Contact Us",
        aboutUs: "About Us",
        projects: "Projects",
        plants: "Plants",
        services: "Services",

        // mobile-sub-menu =>
        subMenuTitle: "Barge Sabz",
        subMenuOption1: "Services",
        subMenuOption2: "Plants",
        subMenuOption3: "Projects",
        subMenuOption4: "About Us",
        subMenuOption5: "Contact Us",

        // sub-menu =>
        filterTitle: "Filters",
        categoryTitle: "Category",

        // landing-page =>
        headerTitle1: "Barge Sabz Company",
        headerTitle2: "Designing & Building Green Spaces",

        bodyOurServicesHeader: "Our Services",
        bodyOurServicesBodyOption1: "Green Roofs & Vertical Gardens",
        bodyOurServicesBodyOption2: "Landscape Design & Planning",
        bodyOurServicesBodyOption3: "Plant Nursery & Plant Store",
        bodyOurServicesBodyOption4: "Maintenance & Aftercare",
        bodyOurServicesBodyOption5: "Water Features",
        bodyOurServicesBodyOption6: "Landscape Lightning",

        bodyPlantsHeader: "Plants",
        bodyViewAllButton: "View All",

        bodyPlantsBodyOption1: "Bouquet",
        bodyPlantsBodyOption2: "Rose",
        bodyPlantsBodyOption3: "Pear",
        bodyPlantsBodyOption4: "Tulip",
        bodyPlantsBodyOption5: "Oak",

        bodyProjectsHeader: "Projects",
        bodyProjectsBodyOption1: "Landscape",
        bodyProjectsBodyOption2: "Terrace",
        bodyProjectsBodyOption3: "Indoor",
        bodyProjectsBodyOption4: "GreenWall",
        bodyProjectsBodyOption5: "office",

        bodyGreenJournalHeader: "Green Journal",

        bodyAboutBargeSabzHeader: "About Barge Sabz",
        bodyAboutBargeSabzTitle: "Barge Sabz Company",
        bodyAboutBargeSabzBody: "Barge sabz is a premium landscape design and execution company specializing in \
                            creating elegant timeless and nature inspired green spaces. We transform \
                            outdoor environments refined living experiences through thoughtful \
                            design quality craftsmanship and a deep respect for nature.",

        fotterContactUsHeader: "Contact Us",

        // projects =>
        filterAndCategoryMenuOption1: "Plants",
        filterAndCategoryMenuOption1_2: "Projects",
        filterAndCategoryMenuOption2: "Discover Beautiful Plants To Every Spaces",
        filterAndCategoryMenuOption3: "Filter & Category",
        filterAndCategoryMenuOption3_2: "Category",
        contentType1: "video",
        contentType2: "image",

        noContent: "No content yet!",

        categoryFilterSubMenuOption1: "None",
        categoryFilterSubMenuOption2: "Indoor",
        categoryFilterSubMenuOption3: "Outdoor",
        categoryFilterSubMenuOption4: "All",
    },
    fa: {
        // menu =>
        companyName: "برگ سبز",

        contactUs: "ارتباط با ما",
        aboutUs: "درباره ما",
        projects: "پروژه ها",
        plants: "گیاهان",
        services: "خدمات",

        // mobile-sub-menu =>
        subMenuTitle: "برگ سبز",
        subMenuOption1: "خدمات",
        subMenuOption2: "گل و گیاه",
        subMenuOption3: "پروژه های اجرا شده",
        subMenuOption4: "درباره ما",
        subMenuOption5: "ارتباط با ما",

        // sub-menu =>
        filterTitle: "فیلتر",
        categoryTitle: "دسته بندی",

        // landing-page =>
        headerTitle1: "برگ سبز",
        headerTitle2: "طراحی ، اجرا و نگهداری فضای سبز",

        bodyOurServicesHeader: "خدمات",
        bodyOurServicesBodyOption1: "طراحی و اجرای بام و دیوار سبز",
        bodyOurServicesBodyOption2: "طراحی و تهیۀ پلان فضای سبز",
        bodyOurServicesBodyOption3: "فروش و عرضۀ گل و گیاه",
        bodyOurServicesBodyOption4: "نگهداری و مراقبت فضای سبز",
        bodyOurServicesBodyOption5: "طراحی و اجرای سیستم های آبیاری",
        bodyOurServicesBodyOption6: "طراحی و اجرای نورپردازی فضای سبز",

        bodyPlantsHeader: "گیاهان",
        bodyViewAllButton: "مشاهده همه",

        // bodyPlantsBodyOption1: "دسته گل",
        // bodyPlantsBodyOption2: "گل رز",
        // bodyPlantsBodyOption3: "گلابی",
        // bodyPlantsBodyOption4: "گل لاله",
        // bodyPlantsBodyOption5: "بلوط",

        bodyProjectsHeader: "پروژه های اجرا شده",
        bodyProjectsBodyOption1: "محوطه سازی",
        bodyProjectsBodyOption2: "تراس و روف",
        bodyProjectsBodyOption3: "فضای داخلی",
        bodyProjectsBodyOption4: "دیوار سبز",
        bodyProjectsBodyOption5: "فضای اداری",

        bodyGreenJournalHeader: "مجله سبز",

        bodyAboutBargeSabzHeader: "درباره برگ سبز",
        bodyAboutBargeSabzTitle: "شرکت برگ سبز",
        bodyAboutBargeSabzBody: "برگ سبز، شرکتی پیشرو در زمینه طراحی و اجرای چشم‌اندازهای (لندسکیپ) ممتاز \
                                 است که در خلق فضاهای سبزِ باشکوه، ماندگار و الهام‌گرفته از طبیعت تخصص دارد. ما \
                                  با بهره‌گیری از طراحی هوشمندانه، هنرِ ساختِ باکیفیت و احترام عمیق به طبیعت، محیط‌های بیرونی \
                                   را به تجربه‌هایی از زندگیِ فرهیخته و تجملاتی تبدیل می‌کنیم.",

        fotterContactUsHeader: "ارتباط با ما",

        // projects =>
        filterAndCategoryMenuOption1: "گیاهان",
        filterAndCategoryMenuOption1_2: "پروژه های اجرا شده",
        filterAndCategoryMenuOption2: "گل و گیاه",
        filterAndCategoryMenuOption3: "فیلتر و دسته بندی",
        filterAndCategoryMenuOption3_2: "دسته بندی",
        contentType1: "ویدیو",
        contentType2: "تصویر",

        noContent: "هنوز محتوایی وجود ندارد",

        categoryFilterSubMenuOption1: "بدون فیلتر",
        categoryFilterSubMenuOption2: "داخلی",
        categoryFilterSubMenuOption3: "خارجی",
        categoryFilterSubMenuOption4: "همه",
    },
};
